import clsx from 'clsx';
import './GrayButton.scss';

type GrayButtonProps = React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>;

const GrayButton: React.FC<GrayButtonProps> = ({
  className,
  children,
  ...props
}) => {
  return (
    <button {...props} className={clsx('gray-button', className)}>
      <div className="gray-button__content">{children}</div>
    </button>
  );
};

export default GrayButton;
